import React from "react";
import { motion } from "framer-motion";
import ArrowLeft from "../../SVGs/nav-menu/ArrowLeft";
import ExternalLink from "../../SVGs/nav-menu/ExternalLink";
import {
  NavMobileType,
  onClickType,
} from "src/assets/Types/Redesign/PrimaryNavMenuType.type";
import { CtaButton } from "@components/RedesignComponents/Cta/cta-button";

type PageDetailsType = {
  data: NavMobileType;
  handleBackContent: () => void;
  onClick: onClickType;
  isFirstItem: boolean;
};

const PageDetails: React.FC<PageDetailsType> = ({
  data,
  handleBackContent,
  onClick,
  isFirstItem,
}) => {
  return (
    <div>
      <motion.div
        key={data?.image}
        initial={{ x: 60, opacity: 0 }}
        animate={data?.image ? { x: 0, opacity: 1 } : { x: 60, opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeOut", delay: 0.38 }}
        className="w-full flex items-center pb-6 sm:pb-4"
      >
        <img
          src={data?.image}
          alt="Main Image"
          className="w-[335px] h-[212px]"
        />
      </motion.div>
      <motion.div
        key={data?.title}
        className={`w-full flex items-center gap-3 header3 ${
          isFirstItem ? "pb-3 sm:pb-2" : " pb-4 sm:pb-3"
        } sm:gap-2 `}
        initial={{ y: 5, opacity: 0 }}
        animate={data?.image ? { y: 0, opacity: 1 } : { y: 5, opacity: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.43 }}
        onClick={handleBackContent}
      >
        <button type="button" className="bg-transparent border-none">
          <ArrowLeft />
        </button>
        <h3>{data?.title}</h3>
      </motion.div>
      <motion.div
        key={data?.subCopy}
        initial={{ y: 10, opacity: 0 }}
        animate={data?.image ? { y: 0, opacity: 1 } : { y: 10, opacity: 0 }}
        transition={{ duration: 0.2, ease: "easeOut", delay: 0.43 }}
        className={`w-full ${
          data?.subGroupLink ? "pb-6 sm:pb-4" : "pb-10 sm:pb-8"
        }`}
      >
        <p className="body--text-small">{data?.subCopy}</p>
      </motion.div>
      {data?.subGroupLink && (
        <motion.div
          key={data?.subGroupLink[0]?.label}
          initial={{ y: 10, opacity: 0 }}
          animate={data?.image ? { y: 0, opacity: 1 } : { y: 10, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut", delay: 0.43 }}
          className="w-full pb-10 flex items-center gap-8 sm:gap-6 sm:pb-8"
        >
          {data?.subGroupLink.map((subGroup, key) => {
            return (
              <CtaButton
                key={key}
                copy={subGroup?.label}
                copySize="bodyRegular"
                isDisabled={false}
                link={subGroup?.link}
                linkUrl={null}
                variant="tertiaryForest"
                onClick={e => onClick(e, { category: data?.name })}
              />
            );
          })}
        </motion.div>
      )}
      <div>
        {data?.groupLinks?.map((item, key) => {
          const newKey = key + 2;

          return (
            <motion.div
              initial={{ y: 15, opacity: 0 }}
              animate={
                data?.image ? { y: 0, opacity: 1 } : { y: 15, opacity: 0 }
              }
              key={item?.title}
              transition={{
                duration: 0.2,
                ease: "easeOut",
                delay: 0.23 * newKey,
              }}
              className={`w-full pb-10 sm:pb-8 last:pb-0`}
            >
              <div className="pb-4 sm:pb-3">
                <span className="text-[14px] font-semibold leading-[1] tracking-[0.28px] uppercase text-forest-900">
                  {item.title}
                </span>
              </div>
              {item?.links?.map((itemLink, linkKey) => {
                const lastItem = linkKey === item?.links?.length - 1;

                return (
                  <div
                    key={linkKey}
                    className={`flex items-center ${
                      !lastItem && "pb-6 sm:pb-4"
                    } `}
                  >
                    <a
                      href={itemLink.link}
                      onClick={e =>
                        onClick(e, {
                          category: data?.name,
                        })
                      }
                      className="body--text-large flex items-center gap-2 no-underline"
                      target={itemLink.icon ? "_blank" : "_self"}
                      rel="noreferrer"
                    >
                      {itemLink.label}
                      {itemLink.icon && <ExternalLink />}
                    </a>
                  </div>
                );
              })}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default PageDetails;
